import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Navigation } from '@/components/Navigation'
import { Footer } from '@/components/Footer'
import { CookieConsentBanner } from '@/components/CookieConsentBanner'
import { CookieConsentProvider } from '@/hooks/useCookieConsent'
import { MarketingInteractions } from './analytics/MarketingInteractions'

const queryClient = new QueryClient()

export const Layout = () => {
  const { i18n } = useTranslation()

  // Keep the document language synchronized after hydration and client-side
  // navigation. The static HTML language is set during the SSG build.
  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <CookieConsentProvider>
            <MarketingInteractions />
            <div className="min-h-screen flex flex-col">
              <Navigation />
              <main className="flex-1">
                <Outlet />
              </main>
              <Footer />
            </div>
            <ScrollRestoration />
            <CookieConsentBanner />
          </CookieConsentProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  )
}
